import React, { useEffect } from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import * as Styles from './_confirmUpdateMarketStatusModal.module.scss';

const ConfirmUpdateMarketStatusModal = () => {
    const isOpen = useAppSelector(state => state.dashboard.modals.isMarketStatusOpenConfirmationModalOpen);
    const isLoading = useAppSelector(state => state.dashboard.loadings.getDashboardMarketStatus);
    const error = useAppSelector(state => state.dashboard.errors.getDashboardMarketStatus);

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.dashboardIsMarketStatusOpenConfimationModalOpen(open));
    const handleSubmitClick = () => dispatch(combinedActions.dashboardOpenDashboardMarketAttempt());

    const handleOnModalClose = () => {
        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={'Confirm Open Market?'}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label={'Confirm'}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={Styles['confirm-approve']}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateMarketStatusModal;
